import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { TraceService } from '@sentry/angular';
import { ValchemyErrorHandler } from './valchemy-error-handler.service';

@NgModule({
  providers: [
    {
      provide: ErrorHandler,
      useClass: ValchemyErrorHandler
    },
    {
      provide: TraceService,
      deps: [Router]
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [TraceService],
      multi: true
    }
  ]
})
export class SentryModule extends NgModule {}
